export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      "J'étais terrifié par la rééducation de l'épaule. Toutes ces phases semblaient impossibles. Après 5 jours avec Rehab 360™, j'ai pu structurer mon premier protocole complet seul. À la semaine 3, j'accompagnais mes athlètes vers un retour au développé-couché en toute confiance.",
    name: 'Marcus T.',
    location: 'Lyon · France',
    flag: '🇫🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/ef84aa00-709f-456f-afe3-7c781c734823.jpg',
  },
  {
    quote:
      'Je gérais des blessures au genou depuis 2 ans, frustrée car mes clients se blessaient à nouveau. La MÉTHODE REHAB 360™ fonctionne vraiment. Je fais maintenant partie de la communauté pro et je coache 15 clients avec des progressions sécurisées.',
    name: 'Sofia L.',
    location: 'Bruxelles · Belgique',
    flag: '🇧🇪',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/549edc20-6760-465c-89a8-3b55e3eebd82.jpg',
  },
  {
    quote:
      "J'avais peur de ne pas être « assez bon » pour gérer des blessures complexes. SIGMA SMART™ m'a prouvé le contraire. La méthode visuelle rend tout limpide. Je me suis senti confiant dès le PREMIER JOUR.",
    name: 'David P.',
    location: 'Genève · Suisse',
    flag: '🇨🇭',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/abeba4cf-9b76-477a-a5c3-062162635fc6.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      "Les fiches de suivi imprimables sont devenues mon outil principal au cabinet. Je sais exactement quand faire progresser la charge. Six semaines plus tard, mes patients reviennent moins souvent pour des rechutes.",
    name: 'Julien R.',
    location: 'Montréal · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/3efc2349-4a3b-468e-81ac-953c40807e03.jpg',
  },
  {
    quote:
      "Le bonus Zéro Équipement m'a sauvée : rééducation de ma cheville entièrement à la maison, avec une chaise et une serviette. Voir chaque phase expliquée visuellement a tout changé.",
    name: 'Emma T.',
    location: 'Paris · France',
    flag: '🇫🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/006283bb-3547-4bf4-a52d-f0c4cd279c9f.jpg',
  },
  {
    quote:
      "Les critères de retour au sport sont ce qui me manquait. Plus de devinettes : mes athlètes reprennent la course avec des points de contrôle clairs. Un vrai système professionnel.",
    name: 'Luc M.',
    location: 'Lausanne · Suisse',
    flag: '🇨🇭',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/b5b63af5-e9fe-4502-8311-a5389f278c65.jpg',
  },
];
